function sliderBeforeAfter () {
    'use strict';

    const $slider = document.querySelector('.slider-before-after');

    if($slider != null) {

        const $after = $slider.querySelector('.slider-after');
        const $track = $slider.querySelector('.slider-track');
        const $icon = $slider.querySelector('.border-icon');

        $track.addEventListener('input', (evt) => {
            var number = 2.5;
            if(window.innerWidth < 700) {
                number = 4;
            }
            const percent = Number(evt.target.value);
            $after.style.width = `${percent}%`;
            $icon.style.left = `${percent - number}% `;
        });

        // $track.value = 33;
        $track.value = 50;

        // if(window.innerWidth < 700) {
        //     $track.value = 50;
        // }
        $track.dispatchEvent(new Event('input'));
    }
}


window.addEventListener('load', sliderBeforeAfter);